import { useState, useContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SLICES } from '../../../../constants/slices';
import { configureHttpClient } from '../../../../utils/payment/httpClientConfig';
import { PAYMENT_METHOD, ACTION_TYPE } from '../../../../constants/constants';
import { BrandContext } from '../../../../contextProviders/brandContext';
import { showSelectAllPetCheckbox, isPetsureUnderwriter } from '../../../../helpers/paymentHelper';

export const useLegacyUpdatePremiumPayment = (
  activePet,
  petDetails,
  onCancel,
  setShowSuccessMessage,
  isPartnerUsingLegacyPayment
) => {
  const [policyDetails, setPolicyDetails] = useState();
  const [updateIsLoading, setUpdateIsLoading] = useState(false);
  const [showFailedUpdateError, setShowFailedUpdateError] = useState(false);
  const { authDetails } = useSelector((state) => state?.[SLICES.AUTHENTICATION]);

  const showSelectAllCheckbox = showSelectAllPetCheckbox(petDetails);

  useEffect(() => {
    configureHttpClient(authDetails);
  }, [authDetails]);

  const isPetsureUw = useMemo(() => {
    if (!activePet || !petDetails) return false;
    return isPetsureUnderwriter({
      petDetails,
      policyNumber: activePet.PolicyNumber
    });
  }, [activePet, petDetails]);

  const {
    activeBrandContext: {
      brand: { partner, broker, partnerPrefix }
    }
  } = useContext(BrandContext);

  useEffect(() => {
    if (activePet && petDetails) {
      setPolicyDetails({
        policyNumber: activePet.PolicyNumber,
        partnerNumber: activePet.PartnerNumber,
        selectAllPetEnabled: showSelectAllCheckbox && petDetails.length > 1
      });
    }
  }, [activePet, petDetails, showSelectAllCheckbox]);

  const westPacPaymentConfig = {
    partner,
    broker,
    partnerPrefix,
    defaultPaymentType: PAYMENT_METHOD.CREDIT_CARD,
    actionType: ACTION_TYPE.UPDATE_BANK,
    useMockData: false,
    environment: process.env.REACT_APP_ENV,
    isPetSureUnderwriter: isPartnerUsingLegacyPayment ? true : isPetsureUw,
    actionButtonsBar: {
      primary: {
        actionItems: [
          {
            id: 'cancelButton',
            buttonStyle: 'secondary',
            buttonLabel: 'Cancel',
            showSpinner: true
          },
          {
            id: 'submitButton',
            buttonStyle: 'primary',
            buttonLabel: 'Update',
            showSpinner: true
          }
        ],
        containerType: 'rows'
      }
    }
  };

  const handleBackToSummary = () => {
    onCancel();
  };

  const handleBeforeSubmit = () => {
    setUpdateIsLoading(true);
  };

  const handleSubmitFail = () => {
    setShowFailedUpdateError(true);
    setUpdateIsLoading(false);
  };

  const handleSubmitSuccess = (response, isApplyToAllPetChecked) => {
    if (response) {
      onCancel();
      setShowSuccessMessage({
        active: true,
        isApplyToAllPetChecked
      });
      return;
    }
    setUpdateIsLoading(false);
    setShowFailedUpdateError(true);
  };

  return {
    updateIsLoading,
    westPacPaymentConfig,
    handleBackToSummary,
    handleBeforeSubmit,
    handleSubmitFail,
    handleSubmitSuccess,
    policyDetails,
    showFailedUpdateError
  };
};
